import type { JsonSchema } from '@jsonforms/core';

type WidgetSettings = Record<string, any>;

export function filterDataBySchema(
  data: WidgetSettings,
  schema: JsonSchema
): WidgetSettings {
  const result: WidgetSettings = {};

  for (const key of Object.keys(data)) {
    const propSchema = schema.properties?.[key];

    if (propSchema) {
      result[key] = data[key];
    }
  }

  return result;
}
